// 9fbef606107a605d69c0edbcd8029e5d
import { call, takeLatest, put, select } from 'redux-saga/effects';
import { setLoaderState } from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import { setUserInfo } from '@tcp/core/src/components/features/account/User/container/User.actions';
import { getIsUserRefreshOnSubscriptionEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { validateReduxCache } from '../../../../../utils/cache.util';
import MY_PREFERENCE_CONSTANTS from '../MyPreferenceSubscription.constants';
import {
  setSubscribeStore,
  subscribeFailure,
  subscribeFailureReset,
} from './MyPreferenceSubscription.actions';
import {
  getPreferencesApi,
  updatePreference,
} from '../../../../../services/abstractors/account/myPreferernce';
import { getProfile } from '../../../../../services/abstractors/account/Login';
import { getsocialAccounts } from '../../../../common/organisms/SocialAccount/container/Social.saga';
import { showError } from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.actions';

export function* getSubscribeStoreSaga() {
  yield put(setLoaderState(true));
  try {
    const subscribeStoreData = yield call(getPreferencesApi);
    yield put(setLoaderState(false));
    const preferences =
      subscribeStoreData?.data?.getSocialCustomerPreferences?.customerPreferencesDTO;
    const modifiedData = {
      CustomerPreferences: preferences?.customerPreferences,
      CustomerPreferencesGym: preferences?.customerPreferencesGym,
      CustomerPreferencesSnj: preferences.customerPreferencesSnj,
      CustomerPreferencesPjp: preferences?.CustomerPreferencesPjp,
      gymSmsPhone: preferences?.gymSmsPhone,
      gymSmsSubscriptionState: preferences?.gymSmsSubscriptionState,
      smsPhone: preferences?.smsPhone,
      smsSubscriptionState: preferences?.smsSubscriptionState,
      snjSmsPhone: preferences?.snjSmsPhone,
      snjSmsSubscriptionState: preferences?.snjSmsSubscriptionState,
      pjpSmsPhone: preferences?.pjpSmsPhone,
      pjpSmsSubscriptionState: preferences?.pjpSmsSubscriptionState,
    };
    const socialAccountInfo =
      subscribeStoreData?.data?.getSocialCustomerPreferences?.socialPreferencesResponseDTO || [];
    yield call(getsocialAccounts, { payload: socialAccountInfo });
    yield put(setSubscribeStore(modifiedData));
  } catch (err) {
    yield put(setLoaderState(false));
    yield null;
  }
}

export function* setSubscribeStoreSaga(data) {
  yield put(setLoaderState(true));
  const { payload } = data;
  const {
    mobileNumber,
    brand,
    CustomerPreferences,
    CustomerPreferencesGym,
    CustomerPreferencesSnj,
    CustomerPreferencesPjp,
  } = payload;
  const customerPreferencesData =
    CustomerPreferencesGym ||
    CustomerPreferences ||
    CustomerPreferencesSnj ||
    CustomerPreferencesPjp;
  try {
    const subscribeStoreData = yield call(
      updatePreference,
      mobileNumber,
      customerPreferencesData,
      brand
    );
    yield put(setLoaderState(false));
    const preferences = subscribeStoreData?.data?.updatePreferences;
    const modifiedData = {
      CustomerPreferences: preferences?.customerPreferences,
      CustomerPreferencesGym: preferences?.customerPreferencesGym,
      CustomerPreferencesSnj: preferences.customerPreferencesSnj,
      CustomerPreferencesPjp: preferences?.CustomerPreferencesPjp,
      gymSmsPhone: preferences?.gymSmsPhone,
      gymSmsSubscriptionState: preferences?.gymSmsSubscriptionState,
      smsPhone: preferences?.smsPhone,
      smsSubscriptionState: preferences?.smsSubscriptionState,
      snjSmsPhone: preferences?.snjSmsPhone,
      snjSmsSubscriptionState: preferences?.snjSmsSubscriptionState,
      pjpSmsPhone: preferences?.pjpSmsPhone,
      pjpSmsSubscriptionState: preferences?.pjpSmsSubscriptionState,
    };
    yield put(setSubscribeStore(modifiedData));
    yield put(subscribeFailureReset());
    const userRefreshOnSubscriptionEnabled = yield select(getIsUserRefreshOnSubscriptionEnabled);
    if (userRefreshOnSubscriptionEnabled) {
      const response = yield call(getProfile, { refresh: true });
      yield put(setUserInfo(response));
    }
  } catch (err) {
    yield put(setLoaderState(false));
    if (err) {
      yield put(showError());
      yield put(subscribeFailure(err[0]));
    }
    yield null;
  }
}

export function* SubscribeStoreSaga() {
  const cachedSubscribeStoreSaga = validateReduxCache(getSubscribeStoreSaga);
  yield takeLatest(MY_PREFERENCE_CONSTANTS.GET_SUBSCRIBE_STORE, cachedSubscribeStoreSaga);
  yield takeLatest(MY_PREFERENCE_CONSTANTS.SET_BRAND_SUBSCRIBE_DATA, setSubscribeStoreSaga);
}

export default SubscribeStoreSaga;
